export class ZonePresence {
    public zone_id: string;
    public duration: number; // in seconds
    public exited?: boolean;
    public entered?: boolean;
}
